import React from 'react';

const OnboardingFooter: React.FC = () => {
  return (
    <div className="mt-8 pt-6 border-t border-gray-100 text-center text-xs text-gray-500">
      <div className="flex flex-wrap justify-center gap-4 mb-2">
        <a href="#" className="hover:text-gray-700 transition-colors">
          Privacy Policy
        </a>
        <a href="#" className="hover:text-gray-700 transition-colors">
          Terms & Conditions
        </a>
      </div>
      <p>© 2024 LovaBuild. All rights reserved.</p>
    </div>
  );
};

export default OnboardingFooter;